import React from 'react';
import { Route, Routes } from "react-router-dom";
import { Grid } from '@mui/material';
import Home from '../Screen/Home';
import Launchpad from '../Screen/Launchpad';
import InfoPage from '../Screen/InfoPage';
import FooterPage from '../Screen/FooterPage';
import GamesPage from '../Screen/GamesPage';
const NavbarRoutes = () => {
  return (
    <>
    <Routes>
        <Route path="/" element={<Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{maxWidth:'100%'}}><Home /></Grid>} />
        <Route path="/launchpad" element={<Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{maxWidth:'100%'}}><Launchpad /></Grid>} />
        <Route path="/games" element={<Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{maxWidth:'100%'}}><GamesPage /></Grid>} />
        <Route path="/guilds" element={<Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{maxWidth:'100%'}}><Home /></Grid>} />
        <Route path="/leaderboard" element={<Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{maxWidth:'100%'}}><Home /></Grid>} />
        <Route path="/staking" element={<Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{maxWidth:'100%'}}><Home /></Grid>} />
        <Route path="/tiers" element={<Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{maxWidth:'100%'}}><Home /></Grid>} />
        <Route path="/info" element={<Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{maxWidth:'100%'}}><InfoPage /></Grid>} />
      </Routes>
      </>
  );
};

export default NavbarRoutes;